module.exports = __webpack_public_path__ + "img/314.7841dc1f.png";